import { render, staticRenderFns } from "./entrustChildInfo.vue?vue&type=template&id=f28e799c&scoped=true&"
import script from "./entrustChildInfo.vue?vue&type=script&lang=js&"
export * from "./entrustChildInfo.vue?vue&type=script&lang=js&"
import style0 from "./entrustChildInfo.vue?vue&type=style&index=0&id=f28e799c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28e799c",
  null
  
)

export default component.exports